module.exports = __webpack_public_path__ + "assets/img/zdban.407d04b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagesInvestment/zdban.png
// module id = otFU
// module chunks = 128